/* cspell: disable*/
import React from 'react';
import './registerConclusionScreen.less';
import { Theme } from '@theme';
import { WithCoreProps, TranslationProps } from 'ff-shared-components-core';
import { Button, Message, LinkLabel, PageScreen, FieldsFormContainer } from '@shared/components';
import { RouteComponentProps } from 'react-router-dom';

interface RegisterConclusionState {
	selectedAccountId: number;
}

interface RegisterConclusionProps {
	onClickNext(data: any): void;
	onClickBack(): void;
	onClickExit(data: any): void;
	alertType: 'successSent' | 'successPending' | 'error' | 'warning' | 'saveOnCancelSuccess';
}

interface RegisterConclusionInjectedProps extends TranslationProps {
	theme: Theme;
}

type Props = RegisterConclusionProps & RegisterConclusionInjectedProps & RouteComponentProps;

class RegisterConclusionScreen extends React.PureComponent<Props, RegisterConclusionState> {
	public constructor(props: Props) {
		super(props);
		window.scrollTo(0, 0);
	}

	public render(): JSX.Element {
		const { t, alertType, onClickExit, onClickBack, onClickNext } = this.props;

		return (
			<PageScreen name="page-register-conclusion top-88px bottom-88px">
				<div className="bottom-88px">
					<Message
						title={this.getAlertType('title')}
						subTittle={this.getAlertType('subtitle')}
						type={
							alertType === 'saveOnCancelSuccess' ||
							alertType === 'successPending' ||
							alertType === 'successSent'
								? 'success'
								: alertType
						}
					></Message>
				</div>

				<FieldsFormContainer>
					<div className="screen-bottom-buttons bottom-88px">
						{alertType === 'warning' && (
							<Button
								onClick={(): void => {
									onClickNext(undefined);
								}}
								primary
								text={t<string>('buttons.general.saveData')}
							/>
						)}
						{alertType === 'warning' && (
							<Button
								tertiary
								text={t<string>('buttons.general.back')}
								onClick={(): void => onClickBack()}
							/>
						)}
						<Button
							primary={
								alertType === 'successPending' ||
								alertType === 'successSent' ||
								alertType === 'saveOnCancelSuccess'
							}
							secondary={alertType === 'warning'}
							text={t<string>('general.button.beginning')}
							onClick={onClickExit}
						/>
					</div>
				</FieldsFormContainer>
			</PageScreen>
		);
	}

	private readonly getAlertType = (aux: string): string => {
		const { alertType, t } = this.props;

		if (aux === 'title') {
			switch (alertType) {
				case 'successSent':
					return t<string>('messageAlerts.registerPharmacy.titles.successSent');
				case 'successPending':
					return t<string>('messageAlerts.registerPharmacy.titles.successPending');
				case 'error':
					return t<string>('messageAlerts.registerPharmacy.titles.error');
				case 'warning':
					return t<string>('messageAlerts.registerPharmacy.titles.warning');
				case 'saveOnCancelSuccess': {
					return t<string>('messageAlerts.registerPharmacy.titles.saveOnCancelSuccess');
				}
				default:
					return '';
			}
		} else {
			switch (alertType) {
				case 'successSent':
					return t<string>('messageAlerts.registerPharmacy.subTitles.successSent');
				case 'successPending':
					return t<string>('messageAlerts.registerPharmacy.subTitles.successPending');
				case 'error':
					return t<string>('messageAlerts.registerPharmacy.subTitles.error');
				case 'warning':
					return t<string>('messageAlerts.registerPharmacy.subTitles.warning');
				case 'saveOnCancelSuccess': {
					return t<string>('messageAlerts.registerPharmacy.subTitles.saveOnCancelSuccess');
				}
				default:
					return '';
			}
		}
	};
}

export default WithCoreProps<RegisterConclusionProps>(RegisterConclusionScreen);
